import Draggable from "react-draggable";
import { FaCheck, FaTimes } from "react-icons/fa";
import { cleanBorder, errorColor, goodColor, primary45 } from "../../utils/color"
import { useState, useEffect, useRef } from "react";
import { TextAlignment } from "pdf-lib";

export default function DraggableText({ onEnd, onSet, onCancel, initialText }) {
  //PC_FG_44
  const [text, setText] = useState("Text");
  //PC_FG_45
  const inputRef = useRef(null);

  //PC_FG_46
  useEffect(() => {
    if (initialText) {
      setText(initialText)
    } else {
      inputRef.current.focus();
      inputRef.current.select()
    }
  }, [])

  //PC_FG_47
  const styles = {
    container: {
      position: "absolute",
      zIndex: 100000,
      border: `2px solid ${primary45}`,
    },
    controls: {
      position: "absolute",
      right: 0,
      display: "inline-block",
      backgroundColor: primary45,
      // borderRadius: 4,
    },
    smallButton: {
      display: "inline-block",
      cursor: "pointer",
      padding: 4,
    },
    input: {
      border: 0,
      fontSize: 18,
      padding: 3,
      backgroundColor: 'rgba(0,0,0,0)',
      cursor: 'move',
    }
  };


  return (
    //PC_FG_49
    <Draggable bounds={{ top: 0, left: 0, bottom: 370, right: 900 }} onStop={onEnd}>
      {/* //PC_FG_50 */}
      <div style={styles.container}>
        {/* //PC_FG_51 */}
        <div style={styles.controls}>
          {/* //PC_FG_52 */}
          <div style={styles.smallButton} onClick={() => onSet(text)}>
            <FaCheck color={goodColor} />
          </div>
          <div style={styles.smallButton} onClick={onCancel}>
            <FaTimes color={errorColor} />
          </div>
        </div>
        {/* //PC_FG_53 */}
        <input
          ref={inputRef}
          style={styles.input}
          value={text}
          placeholder={'Text'}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
    </Draggable>
  );
}
